import React, { useEffect } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import Loader from "./../../shared/loader";
import { fetchBackgroundActors } from "./ducks/actions";
import AddIcon from "../icons/add";
import List from "./list";
import ScrollIntoView from "../../shared/scroll-into-view/scroll-into-view";

function ListActorsContainer(props) {
  const filmId = props.match.params.filmId;
  const { fetchBackgroundActors, loading, actors, errors, readOnly } = props;

  useEffect(() => {
    fetchBackgroundActors(filmId);
  }, []);

  function renderLoading() {
    return <Loader />;
  }

  function renderActors(actors, filmId) {
    return (
      <ScrollIntoView
        className="blade-menu"
        path="/films/:filmId/background-actors"
        loading={loading}>
        <List actors={actors} filmId={filmId} />
        {!readOnly && !window.location.pathname.endsWith("add") && <NavLink
          to={`/films/${filmId}/background-actors/add`}
          activeClassName={
            "is-active " + window.location.pathname.endsWith("add")
              ? "disabled"
              : ""
          }
          className="button is-transparent is-add">
          <AddIcon className="white-icon" />
          Add Actor
        </NavLink>}
        {/*
        <NavLink
          to={`/films/${filmId}/actors/add-from-mandy`}
          activeClassName="is-active"
          className="button is-text is-small mt-1">
          <i className="material-icons">add</i>
          Add from Mandy.com
        </NavLink>
        <NavLink
          to={`/films/${filmId}/actors/add-from-starnow`}
          activeClassName="is-active"
          className="button is-text is-small mt-1">
          <i className="material-icons">add</i>
          Add from StarNow
        </NavLink>
        */}
      </ScrollIntoView>
    );
  }

  return loading ? renderLoading() : renderActors(actors, filmId);
}

function mapStateToProps(state) {
  return {
    actors: state.backgroundActorsState.actors,
    readOnly: state.backgroundActorsState.readOnly,
    loading: state.backgroundActorsState.loading,
    errors: state.backgroundActorsState.errors
  };
}

export default connect(mapStateToProps, {
  fetchBackgroundActors
})(ListActorsContainer);
